import {FileActions} from "../redux_constants/files.constant";
import {post} from "../helper/request";
import {error_manager} from "../helper/error_manager";
import querystring from "query-string";
import {store} from "../helper/store";

const initReadStatus = (readLog) => ({
    type: FileActions.INIT_READ_STATUS, readLog: readLog,
})

const updateReadStatus = (readLog) => ({
    type: FileActions.UPDATE_READ_STATUS, readLog: readLog,
})

export const updateSelectedFile = (file_id) => ({
    type: FileActions.UPDATE_SELECTED_FILE, selected: file_id,
})

export const get_file_read_status = (case_id, file_type) => dispatch => {
    post(`/api/file/get_read_status/`, querystring.stringify({
        case_id: case_id, file_type: file_type,
    }))
        .then(readStatus => dispatch(initReadStatus(readStatus)))
        .catch(error => error_manager("Failed to get file read status", error));
}

export const set_file_read_status = (file_id_list, read_status) => dispatch => {
    if (typeof (file_id_list) !== "object") {
        // If we recieve a single file_id, check if read_status is already satisfied then return
        // else convert it to a list
        if (store.getState().filesReducer.readLog[file_id_list] === read_status) return;
        file_id_list = [file_id_list]
    }
    let read_status_obj = {}
    file_id_list.forEach(file_id => read_status_obj[file_id] = read_status)
    post(`/api/file/set_read_status/`, querystring.stringify({
        file_id_list: file_id_list, read_status: read_status,
    }))
        .then(readStatus => dispatch(updateReadStatus(read_status_obj)))
        .catch(error => error_manager("Failed to set file read status", error));
}